module.exports = __webpack_public_path__ + "static/img/shopNum.daa82311.png";